// extracted by mini-css-extract-plugin
export default {"wrapper":"MainPage_wrapper__4DSOk","wrapper_rusFont":"MainPage_wrapper_rusFont__WvtR7"};